import tippy, { Content, Instance, hideAll } from 'tippy.js';

const getContent = (reference: Element) => {
    const id = reference.getAttribute('data-template');
    return document.getElementById(id as string)?.innerHTML;
};

export const setTooltip = (tooltipTrigger: Element) => {
    const hideAllTooltip = (e: KeyboardEvent) => {
        if (e.key === 'Escape') hideAll();
    };

    const instance = tippy(tooltipTrigger, {
        theme: 'rexTooltip',
        role: 'tooltip',
        content: getContent as Content,
        allowHTML: true,
        delay: 300,
        aria: {
            content: 'labelledby',
        },
        onShow: () => {
            document.addEventListener('keydown', hideAllTooltip);
        },
        onHide: () => {
            document.removeEventListener('keydown', hideAllTooltip);
        },
        placement: 'bottom',
    });

    return instance;
};

export const destroyTooltip = (instance: Instance) => {
    instance && instance.destroy();
};
